import {getWarehouseWindowsBoolean,setWarehouseWindowsBoolean} from '@/config/warehouseWindowsBoolean';

// 全局变量存储当前打开的窗口引用
let currentWindow = null;
const jumpInWarehouse = (component, tokens, names, ids, taskType) => {
    let url = '';
    if (taskType === 'in') {
        url = process.env.VUE_APP_BASE_HTML + '#/inWarehouse';
    } else if (taskType === 'out') {
        url = process.env.VUE_APP_BASE_HTML + '#/outbound';
    } else if(taskType === 'move') {
        url = process.env.VUE_APP_BASE_HTML + '#/inventoryMove';
    } else if(taskType === 'owner') {
        url = process.env.VUE_APP_BASE_HTML + '#/ownerTransfer';
    } else if(taskType === 'count') {
        url = process.env.VUE_APP_BASE_HTML + '#/InventoryCount';
    }else{
        component.$message.error('未知的任务类型');
        return false;
    }
    // const openedWindowsBoolean = localStorage.getItem('openedWindowsBoolean') 
    //     ? JSON.parse(localStorage.getItem('openedWindowsBoolean').toLowerCase()) 
    //     : true;
    const warehouseWindowsBoolean = getWarehouseWindowsBoolean()
    const windowKey = ids === 'add' ? `${taskType}_add` : `${taskType}_${ids}`;
    
    if (!warehouseWindowsBoolean) {
        component.$message.error('已有打开窗口');
        return false;
    }

    const uniqueWindowKey = `PopupWindow_${windowKey}_${Date.now()}`;
    const timestamp = Date.now();
    const uniqueUrl = `${url}?timestamp=${timestamp}&id=${ids}&type=${taskType}`;
    
    const popup = window.open(
        uniqueUrl,
        uniqueWindowKey,
        'width=1860,height=870,top=60,resizable=yes,scrollbars=yes'
    );
    
    if (!popup) {
        component.$message.error('弹窗被阻止！');
        return false;
    }
    // 保存当前窗口引用到全局变量
    currentWindow =  {
        popup: popup,
        component: component,
        key: uniqueWindowKey,
        taskType: taskType,
        taskId: ids === 'add' ? null : ids,
        isAdd: ids === 'add',
        closeTimer: null,
        messageSender: null
    };;

    // 记录打开的窗口信息到组件实例
    component.openedWindows = {
        popup: popup,
        key: uniqueWindowKey,
        taskType: taskType,
        taskId: ids === 'add' ? null : ids,
        isAdd: ids === 'add',
        lastActive: Date.now(),
        // 添加关闭函数引用
        closeWindow: () => {
            if (popup && !popup.closed) {
                try {
                    // 发送关闭消息给子窗口
                    popup.postMessage(
                        { 
                            type: 'CLOSE_WINDOW_FROM_PARENT',
                            timestamp: Date.now()
                        },
                        process.env.VUE_APP_BASE_HTML
                    );
                } catch (e) {
                    // 如果发送消息失败，直接关闭窗口
                    popup.close();
                }
                setWarehouseWindowsBoolean(true);
                component.openedWindows = {};
            }
        }
    };
    setWarehouseWindowsBoolean(false)

    // 窗口关闭检测定时器
    const windowCloseChecker = setInterval(() => {
        if (popup.closed) {
            clearInterval(windowCloseChecker);
            clearInterval(messageSender);
            window.removeEventListener('message', messageHandler);
            setWarehouseWindowsBoolean(true)
            // localStorage.setItem('openedWindowsBoolean', true);
            component.openedWindows = {};
            // 调用组件的刷新方法
            if (component.getTaskList) {
                component.getTaskList();
            }
            if (component.wmsGetKuJianList) {
                component.wmsGetKuJianList();
            }
            if (component.wmsGetInventoryCountList) {
                component.wmsGetInventoryCountList();
            }
            return;
        }
    }, 500);
    
    let tokenReceived = false;
    const messageSender = setInterval(() => {
        if (!tokenReceived) {
            try {
                popup.postMessage(
                    { 
                        type: 'SET_TOKEN', 
                        token: tokens,
                        name: names,
                        parentOrigin: window.location.origin,
                        id: ids === 'add' ? '' : ids,
                    },
                    process.env.VUE_APP_BASE_HTML
                );
            } catch (e) {
                // 忽略跨域错误
            }
        } else {
            clearInterval(messageSender);
        }
    }, 500);
    // 在 messageHandler 中添加
    const messageHandler = (event) => {
        if (event.data.type === 'TOKEN_RECEIVED') {
            tokenReceived = true;
            clearInterval(messageSender);
        }
        if (event.data.type === 'WINDOW_CLOSED') {
            clearInterval(windowCloseChecker);
            clearInterval(messageSender);
            setWarehouseWindowsBoolean(true)
            // localStorage.setItem('openedWindowsBoolean', true);
            component.openedWindows = {};
            if (component.getTaskList) {
                component.getTaskList();
            }
        }
    };
    window.addEventListener('message', (event) => {
        if (event.data.type === 'WINDOW_CLOSED') {
            localStorage.setItem('openedWindowsBoolean', event.data.value);
        }
    });
    return true;
};
// 添加一个关闭所有打开窗口的方法
export function closeAllWarehouseWindows() {
     if (currentWindow && currentWindow.popup && !currentWindow.popup.closed) {
        try {
            currentWindow.popup.postMessage(
                { 
                    type: 'CLOSE_WINDOW_FROM_PARENT',
                    timestamp: Date.now()
                },
                process.env.VUE_APP_BASE_HTML
            );
        } catch (e) {
            currentWindow.popup.close();
        }
        // 清理资源
        setWarehouseWindowsBoolean(true);
    }
}
export { jumpInWarehouse };